import { render } from "./jobbreadcrumb.vue?vue&type=template&id=6d4237b2"
import script from "./jobbreadcrumb.vue?vue&type=script&lang=js"
export * from "./jobbreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__